import Episode from '../../entities/Episode';

import NetAnalyticsParticularEventsRepository from '../../../data/repositories/writer/NetAnalyticsParticularEventsRepository';

import {sendDefaultCustomEvent} from '../../../presentation/helpers/analytics';

export default class EpisodePublicationCreateEvent {
  public async create(episode: Episode) {
    if (!episode.published) {
      return;
    }
    try {
      const analyticsParticularEvent =
        await new NetAnalyticsParticularEventsRepository().create({
          analyticsParticularEventParams: {
            resourceType: 'episode_publication',
            actionName: 'create',
            resourceId: episode.id,
          },
        });
      switch (analyticsParticularEvent.sameEventsCount) {
        case 1:
          sendDefaultCustomEvent({
            resourceType: 'first_episode_publication',
            resourceId: analyticsParticularEvent.userId,
            actionName: 'create',
          });
          break;
        case 2:
          sendDefaultCustomEvent({
            resourceType: 'second_episode_publication',
            resourceId: analyticsParticularEvent.userId,
            actionName: 'create',
          });
          break;
      }
      return analyticsParticularEvent.sameEventsCount;
    } catch (e) {
      return null;
    }
  }
}
